import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { IconType } from 'react-icons';
import { IconWrapper } from '../common/IconWrapper';

export interface Service {
  id: string;
  title: string;
  description: string;
  icon: IconType;
  features: string[];
  link: string;
}

interface ServiceCardProps {
  service: Service;
  index: number;
}

export const ServiceCard: React.FC<ServiceCardProps> = ({ service, index }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ delay: index * 0.1 }}
      className="group"
    >
      <div className="card h-full p-6 hover:translate-y-[-4px] transition-all duration-300">
        <div className="mb-4 inline-block p-3 bg-gradient-to-r from-primary-light/10 to-secondary-light/10 dark:from-primary-dark/10 dark:to-secondary-dark/10 rounded-2xl">
          <IconWrapper
            icon={service.icon}
            className="w-8 h-8 text-primary-light dark:text-primary-dark"
          />
        </div>
        
        <h3 className="text-xl font-semibold mb-3 group-hover:text-primary-light dark:group-hover:text-primary-dark">
          {service.title}
        </h3>
        <p className="text-gray-600 dark:text-gray-400 mb-4">
          {service.description}
        </p>

        <ul className="space-y-2 mb-6">
          {service.features.map((feature, i) => (
            <li key={i} className="flex items-center text-gray-600 dark:text-gray-400">
              <span className="w-1.5 h-1.5 rounded-full bg-primary-light dark:bg-primary-dark mr-2" />
              {feature}
            </li>
          ))}
        </ul>

        <Link
          to={`/services/${service.id}`}
          className="inline-flex items-center text-primary-light dark:text-primary-dark hover:underline"
        >
          Learn More
          <svg
            className="ml-1 w-4 h-4"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M9 5l7 7-7 7"
            />
          </svg>
        </Link>
      </div>
    </motion.div>
  );
};